import cashBookInstance from '../../cashBook/instance'

const getAllCategories = (transactionType) => {
	return cashBookInstance.get(`cash-book/categories?transactionType=${transactionType}`)
}

export default getAllCategories
